import { Component, Input, OnInit } from '@angular/core';
import { Person } from '../../../../models/person';
import { Pagination } from '../../../../models/pagination';
import { PeopleService } from '../../../../services/people.service';
import { CompaniesService } from '../../../../services/companies.service';
import { RegistrationService } from '../../../../services/registration.service';
import { EERegistrationStatus } from '../../../registration/models/EERegistrationInfo';
import { AuthService } from '../../../../services/auth.service';
import { AclService } from '../../../../services/acl.service';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'lib-people-table',
  templateUrl: './people-table.component.html',
  styleUrls: ['./people-table.component.css'],
  standalone: false
})
export class PeopleTableComponent implements OnInit {
  public people: Person[];
  pagination: Pagination;
  public isWhitelistedWithPermission: boolean = false;
  public allowRegistrationResend: boolean = false;
  public registrationInfo: Map<number, EERegistrationStatus>;

  @Input()
  clientCode: string;
  @Input()
  status: string | null = null;

  constructor(
    private peopleService: PeopleService,
    private companyService: CompaniesService,
    private registrationService: RegistrationService,
    public authService: AuthService,
    public aclService: AclService
  ) {}
  ngOnInit() {
    this.peopleService
      .searchPeople(this.clientCode, { pageNumber: 1, perPage: 50, status: this.status })
      .subscribe(ppl => {
        this.people = ppl.Items;
        this.pagination = ppl.Pagination;
      });

    this.companyService.isClientWhitelisted(this.clientCode).subscribe(response => {
      if (response) {
        forkJoin([
          this.aclService.CurrentUserHasMinimumRole('CSR1'),
          this.aclService.CurrentUserAccessCheck(
            'Client Portal Admin',
            'EditPeople',
            this.clientCode
          )
        ]).subscribe(aclResponse => {
          this.isWhitelistedWithPermission = aclResponse[0] || aclResponse[1];
        });
      } else {
        this.isWhitelistedWithPermission = false;
      }
    });

    this.registrationService.getRegistrationByEmployer(this.clientCode).subscribe(result => {
      this.registrationInfo = result;
    });
  }
  getPeopleByLastName(): Person[] {
    return this.people.sort((a, b) => a.LastName.localeCompare(b.LastName));
  }

  loadPage({ Page }: Pagination) {
    this.peopleService
      .searchPeople(this.clientCode, { pageNumber: Page, perPage: 50, status: this.status })
      .subscribe(ppl => {
        this.people = ppl.Items;
        this.pagination = ppl.Pagination;
      });
  }

  getRegistrationStatus(personId: number) {
    this.allowRegistrationResend = false;
    if (personId && this.registrationInfo) {
      let status = this.registrationInfo[personId];
      if (status) {
        switch (status) {
          case EERegistrationStatus.InvitationSent:
            this.allowRegistrationResend = true;
            return 'Invitation Sent';
          case EERegistrationStatus.Registered:
            return 'Registered';
          case EERegistrationStatus.Unregistered:
            return 'Unregistered';
          case EERegistrationStatus.Ineligible:
            return 'Ineligible';
          case EERegistrationStatus.Locked:
            this.allowRegistrationResend = true;
            return 'Locked';
          case EERegistrationStatus.Verified:
            this.allowRegistrationResend = true;
            return 'Verified in Relay';
        }
      } else {
        return 'Unregistered';
      }
    }
    return '';
  }

  resendRegistration(personId: number) {
    if (personId) {
      this.registrationService.resetRegistration(this.clientCode, personId).subscribe();
      this.registrationInfo[personId] = EERegistrationStatus.Unregistered;
    }
  }
}
